import { ItemData } from 'core/models/Template'

export const COMBO_CATALOG_TYPE = 'combo' as const
export const COMBO_CATALOG_TITLE_KEY = 'comboCatalog' as const

export const COMBO_CATALOG_CONFIG = {
    type: COMBO_CATALOG_TYPE,
    additionalData: {},
} as const

export type ComboSelectedItems = ItemData[]
